/**
 * @memberOf app.home
 * @ngdoc controller
 * @name HomeController
 * @description Controller for app.home that handles the scope for the 'home' state.
 */

export default class HomeController {
  constructor(UserService, ReportService, AuthService) {

    /**
     * @memberOf HomeController
     * @type {service}
     * @description Instance of UserService
     */
    this.userService = UserService;

    /**
     * @memberOf HomeController
     * @type {service}
     * @description Instance of ReportService
     */
    this.reportService = ReportService;

    /**
     * @memberOf HomeController
     * @type {service}
     * @description Instance of LoginService
     */
    this.authService = AuthService;

    /**
     * @memberOf HomeController
     * @type {Array}
     * @description An array to hold the reports retrieved for the users
     */
    this.reports;
  }

  /**
   * @memberOf HomeController
   * @description Calls ReportService's getByUser method to retrieve all reports for a user, sets this.reports with result.
   */
  getReports() {
    if (this.authService.isLoggedIn()) {
      let currentPayload = this.authService.currentUser();
      let userId = currentPayload.id;

      this.reportService.getByUser(userId).then((result) => {
        this.reports = result;
      });
    }
  }

  /**
   * @memberOf HomeController
   * @description Checks if the user is logged in, calls AuthService's isLoggedIn method
   * @returns {Boolean} True if user is logged in, false otherwise
   */
  isLoggedIn() {
    return this.authService.isLoggedIn();
  }
}

HomeController.$inject = ['UserService', 'ReportService', 'AuthService'];



// WEBPACK FOOTER //
// ./src/client/app/home/home.controller.js